module.exports = __webpack_public_path__ + "img/1f_r_tonya.c033eb5c.png";